<!-- ================================== -->
<!-- Privacy Policy Banner start here... -->
<!-- ================================== -->
<section class="inhoused">
  <div class="max-width-container">
    <div class="container position-relative z-3">
      <h1>Privacy Policy</h1>
      <p class="fw-bold">Effective Date: 23 April 2025</p>
      <p>
        Reali Supply (Chicago Apparel Pty Ltd A.C.N. 148 998 029 ATF One Stop Workwear Unit Trust, ABN 72 360 818 347)
        respects your privacy and is committed to protecting the personal information you provide to us. This policy
        outlines how we collect, use, store, and disclose your information.
      </p>
    </div>
  </div>
</section>
<!-- ================================= -->
<!-- Privacy Policy Banner end here... -->
<!-- ================================== -->

<!-- ================================= -->
<!-- Privacy Policy content start here... -->
<!-- ================================== -->
<section class="about-ship-delivery">
  <div class="max-width-container">
    <div class="container">
      <div class="conditions">
        <h2>1. What Information We Collect</h2>
        <p class="mb-4">
          We may collect the following types of personal information:
        </p>
        <ul class="list-condition">
          <li>
            <p>
              Name, company name, and job title
            </p>
          </li>
          <li>
            <p>
              Business address and contact details (email, phone number)
            </p>
          </li>
          <li>
            <p>
              Industry or company size
            </p>
          </li>
          <li>
            <p>
              Order details and preferences
            </p>
          </li>
          <li>
            <p>
              Payment information (only processed via secure third-party providers)
            </p>
          </li>
          <li>
            <p>
              SUMS user account details and login history
            </p>
          </li>
          <li>
            <p>Any other information you voluntarily submit via forms or correspondence</p>
          </li>
        </ul>
      </div>
      <div class="conditions">
        <h2>2. How We Collect Your Information</h2>
        <p class="mb-4">
          We collect your information when you:
        </p>
        <ul class="list-condition">
          <li>
            <p>
              Submit a contact or enquiry form
            </p>
          </li>
          <li>
            <p>Place an order on our website</p>
          </li>
          <li>
            <p>
              Register for access to SUMS
            </p>
          </li>
          <li>
            <p>
              Communicate with us via email, phone, or live chat
            </p>
          </li>
          <li>
            <p>
              Participate in surveys, offers, or events
            </p>
          </li>
        </ul>
      </div>
      <div class="conditions">
        <h2>3. How We Use Your Information</h2>
        <p class="mb-4">Your information is used to:</p>
        <ul class="list-condition">
          <li>
            <p>Process and fulfil your orders</p>
          </li>
          <li>
            <p>
              Create and manage your account(s), including SUMS access
            </p>
          </li>
          <li>
            <p>
              Communicate important updates about products or services
            </p>
          </li>
          <li>
            <p>
              Provide technical or customer support
            </p>
          </li>
          <li>
            <p>
              Send relevant marketing communications (where consented)
            </p>
          </li>
          <li>
            <p>
              Improve our website and service offerings
            </p>
          </li>
        </ul>
      </div>
      <div class="conditions">
        <h2>4. Disclosure of Personal Information</h2>
        <p class="mb-4">
          We do not sell or rent your personal information. We may share your data with:
        </p>
        <ul class="list-condition">
          <li>
            <p>
              Third-party service providers who support our operations (e.g. couriers, decorators, IT support)
            </p>
          </li>
          <li>
            <p>
              Regulatory or legal authorities if required by law
            </p>
          </li>
          <li>
            <p>
              Our trusted staff and contractors who need access to perform business services
            </p>
          </li>
        </ul>
        <p class="mb-4">
          All third parties are required to keep your information confidential and use it only for authorised purposes.
        </p>
      </div>
      <div class="conditions">
        <h2>5. Data Security</h2>
        <p class="mb-4">
          We use industry-standard security measures to protect your data, including:
        </p>
        <ul class="list-condition">
          <li>
            <p>
              Secure server environments
            </p>
          </li>
          <li>
            <p>
              Two-factor authentication for SUMS users
            </p>
          </li>
          <li>
            <p>
              Single Sign-On (SSO) options for enterprise clients
            </p>
          </li>
          <li>
            <p>
              Regular system updates and access controls
            </p>
          </li>
        </ul>
        <p class="mb-4">
          Despite our efforts, no method of electronic transmission or storage is 100% secure. We cannot guarantee
          absolute security.
        </p>
      </div>
      <div class="conditions">
        <h2>6. Access & Correction</h2>
        <ul class="list-condition">
          <li>
            <p>
              You may request access to your personal information, or ask us to update or correct it. Please contact us
              at <a href="mailto:uniforms@reali.au" class="btn btn-link d-inline-flex px-0" role="button">
                uniforms@reali.au
              </a> for assistance. We will respond to your request within a reasonable timeframe.
            </p>
          </li>
        </ul>
      </div>
      <div class="conditions">
        <h2>7. Cookies & Site Analytics</h2>
        <ul class="list-condition">
          <li>
            <p>
              Our website uses cookies and third-party analytics tools (like Google Analytics) to improve functionality
              and user experience. You can disable cookies via your browser settings if you prefer.
            </p>
          </li>
        </ul>
      </div>
      <div class="conditions">
        <h2>8. International Data Transfers</h2>
        <ul class="list-condition">
          <li>
            <p>
              We primarily operate in Australia and New Zealand. If data is stored or accessed by overseas service
              providers, we ensure that adequate data protection measures are in place.
            </p>
          </li>
        </ul>
      </div>
      <div class="conditions">
        <h2>9. Marketing Communications</h2>
        <ul class="list-condition">
          <li>
            <p>
              You may receive occasional emails about new products or offers. You can opt out at any time by clicking
              the <strong>unsubscribe</strong> link in our emails or contacting us directly.
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
<!-- ================================= -->
<!-- Privacy Policy content end here... -->
<!-- ================================== -->